<template>
	<div class="content">
		<div class="menu-right">
			<div class="title">
				<span>快递回收</span>
			</div>
			<div class="inner" v-for="(item,index) in clauseList" :key="index">
				<div class="sm-title">{{item.title}}</div>
				<p v-for="(item1,index1) in item.list" :key="index1">{{item1.text}}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data(){
		return {
			clauseList: [
				{
					title: '',
					list: [
						{text: '陌陌回收目前支持100个品牌，30000+款国际国内主流移动终端（手机+平板+笔记本+数码产品）回收。如果发现您的机型不在回收范围内，可以联系陌陌回收客服进行添加；脏机、黑机、开启丢失模式的机器不支持回收。'}
					]
				},
				{
					title: '第一步，快递上门，顺丰包邮',
					list:[
						{text: '填写收款信息，选择回收方式，提交订单，一键下单顺丰上门收件或自行邮寄回收；'},
						{text: '邮寄回收：用户在邮寄机器时，请优先选择顺丰到付。笔记本、无人机、包邮上限为40元，其它物品如手机、平板、相机等包邮上限为22元。超额部分、包装费、保价费需用户承担。若用户使用寄付(走顺丰以外的快递请先垫付快递费)，订单成交后我司会给予报销邮费，每单最高补贴12元。若您有多部机器回收，请将多部机器打包到一个包裹寄出，陌陌回收只承担一次运费。'}
					]
				},
				{
					title: '第二步，收货质检，全程跟进',
					list:[
						{text: '用户在陌陌回收页面选择需要回收的数码产品品牌、型号，根据数码产品的实际情况，如实对功能情况等进行勾选，陌陌回收实时报价； 陌陌回收根据大数据以及您对物品的描述，评估商品的回收价格。鉴于电子产品价格的特殊性，估价并非最终成交价。您应保证自己填写的机器参数信息准确、真实、有效。以免因错填信息导致影响最终成交价格。'},
						{text: '邮寄地址：广东省深圳市龙华新区华荣路163号荣泰大厦1112（室）陌陌回收（收）'},
						{text: '电话号码：0755-21036187。'},
						{text: '您将物品寄出后，应妥善保留快递单等所有证明对物品所有权的证据。 您应该清楚地知道，陌陌回收收到物品前的风险应由您自行承担，陌陌回收不承担任何因您或其它任何第三方过失导致物品丢失或损坏产生的直接或间接赔偿。'}
					]
				},
				{
					title: '第三步，数据清除，隐私安全',
					list:[
						{text: '陌陌回收在收到物品后会根据您之前选择的物品参数进行核对以及检测。如因您选择的物品参数与实物不符，根据物品的实际情况，与您协商确认最终成交价格； 陌陌回收承诺在收到机器的24小时内为您检测完毕。 陌陌回收承诺对每个机器都采用标准的质检流程。 陌陌回收承诺仅打开手机后盖检测（包含一体机，如：苹果手机），绝不拆解手机内部配件，且整个检测过程都有高清监控。'}
					]
				},
				{
					title: '第四步，确认价格，极速收款',
					list:[
						{text: '陌陌回收会在收货后24小时内完成检测并付款。如产品描述与检测结果一致，则立刻完成打款并以短信或者微信通知告知；如果产品描述以及检测结果不一致，陌陌回收会根据机器实际情况，与您确认最终回收价。如果您同意最终回收价，陌陌回收则会进行付款。如果您不同意最终回收价，可以要求退货，退货邮费将由客户自行承担。'}
					]
				},
				{
					title: '第五步，完成交易',
					list:[
						{text: '陌陌回收付款方式支持支付宝、微信。如果您采取邮寄交易方式，陌陌回收检测完毕后，确认物品最终成交价，会在24小时内完成付款并发送短信通知； 上门交易方式，当面确认成交价，确认成交价后当即支付。交易完成后若发生任何款项争议或其它纠纷的，陌陌回收不承担任何责任。'},
					]
				}
			],
		}
	}
}
</script>

<style scoped>
.menu-right .title span{
	font-size: 24px;
	border-bottom: 3px solid #3c78eb;
	padding-bottom: 4px;
}

.menu-right p{
	font-size: 16px;
	line-height: 30px;
	color: #282828;
	margin-top: 20px;
}

.menu-right .inner .sm-title{
	margin-top: 20px;
	color: #3c78eb;
}
</style>
